// @flow
import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ListPager from 'components/organisms/ListPager'
import { containerIds, setUIState } from 'redux/modules/ui'
import {
  type SearchConditionType,
  setSearchCondition,
} from 'redux/modules/search'
import { formatPagerText } from 'frontend_core/dist/helpers/format'
import { queryStringStringify } from 'helpers/search'

function Container(props) {
  const {
    ui,
    location,
    actions,
    pageInfo,
    perPage,
    totalCount,
    searchSessionId,
  } = props

  // ページ情報
  const pagerText = formatPagerText(pageInfo, perPage)

  function getPageLink(page: number) {
    const newSearchCondition = Object.assign({}, props.search, {
      page,
      searchSessionId: searchSessionId,
    })
    return `${location.pathname}?${queryStringStringify(newSearchCondition)}`
  }

  function onChangePage(page: number) {
    const uiSearchCondition = ui.searchCondition || {}
    actions.setUIState(containerIds.SEARCH, {
      searchCondition: Object.assign({}, uiSearchCondition, {
        page,
      }),
    })
    actions.setSearchCondition({ page })
    window.scrollTo(0, 0)
  }

  return (
    <ListPager
      totalCount={totalCount}
      totalCountDisplay={pagerText.totalCountDisplay}
      currentCountDisplay={pagerText.currentCountDisplay}
      currentPage={pageInfo.currentPage}
      totalPages={pageInfo.totalPages}
      previousPage={pageInfo.previousPage}
      nextPage={pageInfo.nextPage}
      windowSize={4.5}
      getPageLink={getPageLink}
      onChangePage={onChangePage}
    />
  )
}

function mapStateToProps(state: Object) {
  return state
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, setSearchCondition }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Container),
)



// WEBPACK FOOTER //
// ./src/containers/organisms/ListPager/index.jsx